var _rect, _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBgVisit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 152,
    height: 152,
    viewBox: "0 0 152 152",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 151.844,
    height: 151.844,
    rx: 75.922,
    fill: "#ECF5F0"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M104.948 82.8418H47.1617C45.4081 82.8418 44 81.4071 44 79.6802V67.0601C44 65.3331 45.4081 63.8984 47.1617 63.8984H104.948C106.702 63.8984 108.11 65.3066 108.11 67.0601V79.6536C108.083 81.4071 106.675 82.8418 104.948 82.8418Z",
    fill: "#05D484"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M101.097 73.3803C101.097 79.6771 98.7859 85.4159 94.9601 89.7997H57.153C53.3271 85.4159 51.0156 79.6771 51.0156 73.3803C51.0156 67.0836 53.3537 61.3713 57.1795 56.9609H94.9335C98.7859 61.3713 101.097 67.0836 101.097 73.3803Z",
    fill: "#05D484"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M76.0428 49.6569C62.9394 49.6569 52.317 60.2792 52.317 73.3826C52.317 86.486 62.9394 97.1084 76.0428 97.1084C89.1461 97.1084 99.7685 86.486 99.7685 73.3826C99.7685 60.2792 89.1461 49.6569 76.0428 49.6569ZM49.6602 73.3826C49.6602 58.8119 61.4721 47 76.0428 47C90.6135 47 102.425 58.8119 102.425 73.3826C102.425 87.9533 90.6135 99.7652 76.0428 99.7652C61.4721 99.7652 49.6602 87.9533 49.6602 73.3826Z",
    fill: "#09081A"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M94.4738 90.3594L106.244 102.395L104.344 104.253L92.5742 92.217L94.4738 90.3594Z",
    fill: "#09081A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgVisit);
export default __webpack_public_path__ + "static/media/BgVisit.43f39b38.svg";
export { ForwardRef as ReactComponent };